import store from 'store';
import FCM from '../../helpers/FirebaseCloudMessaging';

const LOGIN = '@@auth/LOGIN';
export const LOGIN_SUCCESS = '@@auth/LOGIN_SUCCESS';
const LOGIN_FAIL = '@@auth/LOGIN_FAIL';

const LOGOUT = '@@auth/LOGOUT';
const LOGOUT_SUCCESS = '@@auth/LOGOUT_SUCCESS';
const LOGOUT_FAIL = '@@auth/LOGOUT_FAIL';

const SETPASSWORD = '@@auth/SETPASSWORD';
const SETPASSWORD_SUCCESS = '@@auth/SETPASSWORD_SUCCESS';
const SETPASSWORD_FAIL = '@@auth/SETPASSWORD_FAIL';

const RESETPASSWORD = '@@auth/RESETPASSWORD';
const RESETPASSWORD_SUCCESS = '@@auth/RESETPASSWORD_SUCCESS';
const RESETPASSWORD_FAIL = '@@auth/RESETPASSWORD_FAIL';

const INIT = '@@auth/INIT';
export const INIT_SUCCESS = '@@auth/INIT_SUCCESS';
const INIT_FAIL = '@@auth/INIT_FAIL';

const initialState = {
	acl: {},
	initing: false,
	loaded: false
};

export default function reducer(state = initialState, action = {}) {
	switch (action.type) {
		case LOGIN:
			return {
				...state,
				loggingIn: true
			};
		case INIT:
			return {
				...state,
				initing: true
			};
		case LOGIN_SUCCESS:
		case INIT_SUCCESS:
			window.CSRF = action.result.auth.csrf;
			if (__MOBILE__) {
				store.set('auth', action.result.token);
				window.XAuth = action.result.token;
			}
			return {
				...state,
				acl: action.result.acl,
				initing: false,
				loggingIn: false,
				isLoggedIn: true,
				roles: action.result.auth.roles,
				identity: action.result.auth.identity,
				fbapp: action.result.auth.fbapp
			};
		case LOGIN_FAIL:
		case INIT_FAIL:
			if (__MOBILE__) {
				store.set('auth', null);
			}
			return {
				...state,
				initing: false,
				loggingIn: false,
				isLoggedIn: false,
				loginError: action.error.message
			};
		case LOGOUT:
			if (__MOBILE__) {
				store.set('auth', null);
			}
			return {
				...state,
				loggingOut: true
			};
		case LOGOUT_SUCCESS:
			return {
				...state,
				loggingOut: false,
				isLoggedIn: false,
				identity: null
			};
		case LOGOUT_FAIL:
			return {
				...state,
				loggingOut: false,
				logoutError: action.error
			};
		default:
			return state;
	}
}

const fcm = new FCM();

export function init(data) {
	return {
		types: [INIT, INIT_SUCCESS, INIT_FAIL],
		promise: (client) => client.call('init', {data: {fcm: fcm.getToken()}})
	};
}

export function login(values) {
	return {
		types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
		promise: (client) => client.call('login', {...values, fcm: fcm.getToken()}, {progress: true})
	};
}

export function logout(device) {
	return {
		types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
		promise: (client) => client.call('logout', {device}, {progress: true})
	};
}

export function setPassword(token, password) {
	return {
		types: [SETPASSWORD, SETPASSWORD_SUCCESS, SETPASSWORD_FAIL],
		promise: (client) => client.call('setPassword', {token, password}, {progress: true})
	};
}

export function resetPassword(email) {
	return {
		types: [RESETPASSWORD, RESETPASSWORD_SUCCESS, RESETPASSWORD_FAIL],
		promise: (client) => client.call('resetPassword', {email}, {progress: true})
	};
}


// WEBPACK FOOTER //
// ./src/redux/modules/auth.js